import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

/**
 * @param {string} value
 */
export default class TruncatedColumn extends Component {
  @tracked wasTruncated = false;
}
